<template>
	<!-- Main content -->

	<div class="row">

		<div class="col-md-12">
			<div class="box box-solid">

				<div class="box-header with-border">
					<h3 class="box-title"><i class="fa fa-search"></i> <b>Resultado da Consulta Restritiva</b></h3>
				</div>

				<div class="box-body">

					<div v-if="resultado.restricao" class="alert alert-danger alert-dismissible">
						<h4><i class="icon fa fa-ban"></i> Restrições encontradas! </h4>
						O documento consultado possui débitos e/ou restrições.
					</div>


					<div v-if="!resultado.restricao" class="alert alert-success alert-dismissible">
						<h4><i class="icon fa fa-check"></i> Tudo certo! </h4>
						O documento consultado não possui débitos e/ou restrições.
					</div>


					<div v-if="!resultado" class="alert alert-warning alert-dismissible">
						<h4><i class="icon fa fa-warning"></i> Problema na consulta! </h4>
						Ocorreu algum erro no retorno dos dados. Contate o administrador do sistema...
					</div>

					<div class="nav-tabs-custom">
						<ul class="nav nav-tabs">
							<li class="active"><a href="#tab_resumo" data-toggle="tab"><i class="fa fa-file-text-o"></i> Resumo</a></li>
							<li><a href="#tab_debitos" data-toggle="tab">Débitos e Restrições ({{resultado.spc.resumo['quantidade-total']+
								resultado.ccf.resumo['quantidade-total']+
								resultado['cheque-lojista'].resumo['quantidade-total']+
								resultado['contra-ordem'].resumo['quantidade-total']+
								resultado['contra-ordem-documento-diferente'].resumo['quantidade-total']+
								resultado.contumacia.resumo['quantidade-total']+(resultado.protesto?resultado['protesto'].resumo['quantidade-total']:0)}})</a></li>
								<li><a href="#tab_outras" data-toggle="tab">Outras Informações</a></li>
								<li><a href="#tab_alertas" data-toggle="tab">Alertas e Históricos ({{resultado['consulta-realizada'].resumo['quantidade-total']+
									resultado['alerta-documento'].resumo['quantidade-total']}})</a></li>

								</ul>
								<div class="tab-content">
									<div class="tab-pane active" id="tab_resumo">
										<div class="row">
											<div class="col-md-12 form-group">

												<div style="margin-top:2px; font-size:12px;">
													<h5>DADOS DA CONSULTA</h5>
													<table class="table table-bordered table-hover" role="grid">
														<thead>
															<tr class="">
																<th style="font-weight:bold; width:auto">NÚMERO DA CONSULTA</th>
																<th style="font-weight:bold; width:auto">DOCUMENTO</th>
																<th style="font-weight:bold; width:auto">DATA</th>
																<th style="font-weight:bold; width:auto">HORA</th>
															</tr>
														</thead>

														<tbody>
															<tr class="">
																<td style="vertical-align:center">{{resultado.protocolo.numero}}-{{resultado.protocolo.digito}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-fisica']?resultado.consumidor['consumidor-pessoa-fisica'].cpf.numero:resultado.consumidor['consumidor-pessoa-juridica'].cnpj.numero}}</td>
																<td style="vertical-align:center">{{ resultado.data }}</td>
																<td style="vertical-align:center">{{ resultado.data }}</td>                   
															</tr>
														</tbody>  
													</table>

												</div>

												<div v-if="resultado.consumidor['consumidor-pessoa-fisica']" style="margin-top:2px; font-size:12px;">
													<h5>DADOS PESSOAIS</h5>
													<table class="table table-bordered table-hover" role="grid">
														<thead>
															<tr class="">
																<th style="font-weight:bold; width:auto">NOME</th>
																<th style="font-weight:bold; width:auto">CPF</th>
																<th style="font-weight:bold; width:auto">RG</th>
																<th style="font-weight:bold; width:auto">DATA DE NASC.</th>
																<th style="font-weight:bold; width:auto">IDADE</th>
																<th style="font-weight:bold; width:auto">NOME DA MÃE</th>
															</tr>
														</thead>
														<tbody>
															<tr class="">
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-fisica'].nome}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-fisica'].cpf.numero}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-fisica']['numero-rg']}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-fisica']['data-nascimento']}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-fisica'].idade}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-fisica']['nome-mae']}}</td>
															</tr>
														</tbody>    
													</table>
												</div>

												<div v-if="resultado.consumidor['consumidor-pessoa-juridica']" style="margin-top:2px; font-size:12px;">
													<h5>DADOS EMPRESARIAS</h5>
													<table class="table table-bordered table-hover" role="grid">
														<thead>
															<tr class="">
																<th style="font-weight:bold; width:auto">RAZÃO SOCIAL</th>
																<th style="font-weight:bold; width:auto">NOME COMERCIAL</th>
																<th style="font-weight:bold; width:auto">CNPJ</th>
																<th style="font-weight:bold; width:auto">DATA FUNDAÇÃO</th>
															</tr>
														</thead>
														<tbody>
															<tr class="">
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-juridica']['razao-social']}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-juridica']['nome-comercial']}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-juridica'].cnpj.numero}}</td>
																<td style="vertical-align:center">{{resultado.consumidor['consumidor-pessoa-juridica']['data-fundacao']}}</td>
															</tr>
														</tbody>    
													</table>
												</div>


												<div style="margin-top:2px; font-size:12px;">
													<h5>RESUMO DAS OCORRÊNCIAS</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class="">
																<th>OCORRÊNCIA</th>
																<th>QUANTIDADE</th>
																<th>ÚLTIMA OCORRÊNCIA</th>
																<th>VALOR</th>
															</tr>
														</thead>
														<tbody>

															<tr v-if="resultado.protesto" style="background-color: #f7f08e">
																<td>Protestos em Cartório</td>
																<td>{{ resultado.protesto.resumo['quantidade-total'] }}</td>
																<td>{{ resultado.protesto.resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado.protesto.resumo['valor-total'] }}</td>
															</tr>

															<tr>
																<td>Registro de SPC</td>
																<td>{{ resultado.spc.resumo['quantidade-total'] }}</td>
																<td>{{ resultado.spc.resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado.spc.resumo['valor-total'] }}</td>
															</tr>
															
															<tr>
																<td>Cheques Sem Fundo - CCF</td>
																<td>{{ resultado.ccf.resumo['quantidade-total'] }}</td>
																<td>{{ resultado.ccf.resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado.ccf.resumo['valor-total'] }}</td>
															</tr>
															<tr>
																<td>Registro de Cheques - Lojistas</td>
																<td>{{ resultado['cheque-lojista'].resumo['quantidade-total'] }}</td>
																<td>{{ resultado['cheque-lojista'].resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado['cheque-lojista'].resumo['valor-total'] }}</td>
															</tr>

															<tr>
																<td>Consultas Realizadas</td>
																<td>{{ resultado['consulta-realizada'].resumo['quantidade-total'] }}</td>
																<td>{{ resultado['consulta-realizada'].resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado['consulta-realizada'].resumo['valor-total'] }}</td>
															</tr>
															<tr>
																<td>Alertas de Documentos</td>
																<td>{{ resultado['alerta-documento'].resumo['quantidade-total'] }}</td>
																<td>{{ resultado['alerta-documento'].resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado['alerta-documento'].resumo['valor-total'] }}</td>
															</tr>
															<tr>
																<td>Contra Ordem</td>
																<td>{{ resultado['contra-ordem'].resumo['quantidade-total'] }}</td>
																<td>{{ resultado['contra-ordem'].resumo['data-ultima-ocorrencial'] }}</td>
																<td>{{ resultado['contra-ordem'].resumo['valor-total'] }}</td>
															</tr>
															<tr>
																<td>Contra Ordem - (Doc diferente do consultado)</td>
																<td>{{ resultado['contra-ordem-documento-diferente'].resumo['quantidade-total'] }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente'].resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente'].resumo['valor-total'] }}</td>
															</tr>
															<tr>
																<td>Contumácia</td>
																<td>{{ resultado.contumacia.resumo['quantidade-total'] }}</td>
																<td>{{ resultado.contumacia.resumo['data-ultima-ocorrencia'] }}</td>
																<td>{{ resultado.contumacia.resumo['valor-total'] }}</td>
															</tr>
														</tbody>

													</table>	
												</div>
											</div>
										</div>
									</div>
									<div class="tab-pane" id="tab_debitos">
										<div class="row">
											<div class="col-md-12 form-group">	


												<!-- OCORRẼNCIAS DE DEBITO -->								
												<div v-if="resultado.protesto && resultado.protesto.resumo['quantidade-total'] > 0" style="margin-top:2px; font-size:12px;">
													<h5>PROTESTOS EM CARTÓRIO</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th>DT. PROTESTO</th>
																<th>CARTÓRIO</th>
																<th>CIDADE</th>
																<th>ESTADO</th>
																<th>VALOR</th>                        
															</tr>
														</thead>

														<tbody>

															<tr v-if="resultado.protesto.resumo['quantidade-total'] == 1">
																<td>{{ resultado.protesto['detalhe-protesto']['data-protesto'] }}</td>
																<td>{{ resultado.protesto['detalhe-protesto'].cartorio.nome }}</td>
																<td>{{ resultado.protesto['detalhe-protesto'].cartorio.cidade.nome }}</td>
																<td>{{ resultado.protesto['detalhe-protesto'].cartorio.cidade.estado['sigla-uf'] }}</td>
																<td>{{ resultado.protesto['detalhe-protesto'].valor }}</td>
															</tr> 

															<tr v-if="resultado.protesto.resumo['quantidade-total'] > 1" v-for="item in resultado.protesto['detalhe-protesto']">
																<td>{{ item['data-protesto'] }}</td>
																<td>{{ item.cartorio.nome }}</td>
																<td>{{ item.cartorio.cidade.nome }}</td>
																<td>{{ item.cartorio.estado['sigla-uf'] }}</td>
																<td>{{ item.valor }}</td>
															</tr>                
														</tbody>  
													</table> 
												</div>

												<!-- OCORRẼNCIAS DE DEBITO -->								
												<div v-if="resultado.spc.resumo['quantidade-total'] > 0" style="margin-top:2px; font-size:12px;">
													<h5>OCORRÊNCIAS DE DÉBITO</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th>DT. VCTO</th>
																<th>DT. ENTRADA</th>
																<th>VALOR</th>
																<th>CONTRATO</th>
																<th>INFORMANTE</th>
																<th>ORIGEM</th>                            
															</tr>
														</thead>

														<tbody>

															<tr v-if="resultado.spc.resumo['quantidade-total'] == 1">
																<td>{{ resultado.spc['detalhe-spc']['data-vencimento'] }}</td>
																<td>{{ resultado.spc['detalhe-spc']['data-inclusao'] }}</td>
																<td>{{ resultado.spc['detalhe-spc'].valor }}</td>
																<td>{{ resultado.spc['detalhe-spc'].contrato }}</td>
																<td>{{ resultado.spc['detalhe-spc']['nome-associado'] }}</td>
																<td>{{ resultado.spc['detalhe-spc']['nome-entidade'] }}</td>
															</tr> 

															<tr v-if="resultado.spc.resumo['quantidade-total'] > 1" v-for="item in resultado.spc['detalhe-spc']">
																<td>{{ item['data-vencimento'] }}</td>
																<td>{{ item['data-inclusao'] }}</td>
																<td>{{ item.valor }}</td>
																<td>{{ item.contrato }}</td>
																<td>{{ item['nome-associado'] }}</td>
																<td>{{ item['nome-entidade'] }}</td>
															</tr>                
														</tbody>  
													</table> 
												</div>

												<!-- OCORRẼNCIAS DE CHEQUE (LOJISTAS) -->	
												<div v-if="resultado['cheque-lojista'].resumo['quantidade-total'] > 0" style="margin-top:2px; font-size:12px;">
													<h5>OCORRÊNCIAS DE CHEQUE (LOJISTAS)</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th style="font-weight:bold; width:auto">ALÍNEA</th>
																<th style="font-weight:bold; width:auto">DT. INCLUSÃO</th>
																<th style="font-weight:bold; width:auto">AG</th>
																<th style="font-weight:bold; width:auto">BANCO</th>
																<th style="font-weight:bold; width:auto">INFORMANTE</th>
																<th style="font-weight:bold; width:auto">ORIGEM</th> 
															</tr>
														</thead>
														<tbody>
															<tr v-if="resultado['cheque-lojista']['detalhe-cheque-lojista'].length == 1">
																<td>{{ resultado['cheque-lojista']['detalhe-cheque-lojista'].alinea.descricao }}</td>
																<td>{{ resultado['cheque-lojista']['detalhe-cheque-lojista']['data-inclusao'] }}</td>
																<td>{{ resultado['cheque-lojista']['detalhe-cheque-lojista']['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ resultado['cheque-lojista']['detalhe-cheque-lojista']['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ resultado['cheque-lojista']['detalhe-cheque-lojista'].informante }}</td>
																<td>{{ resultado['cheque-lojista']['detalhe-cheque-lojista'].origem }}</td>
															</tr> 

															<tr v-if="resultado['cheque-lojista']['detalhe-cheque-lojista'].length > 1" v-for="item in resultado['cheque-lojista']['detalhe-cheque-lojista']">
																<td>{{ item.alinea.descricao }}</td>
																<td>{{ item['data-inclusao'] }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ item.informante }}</td>
																<td>{{ item.origem }}</td>
															</tr>     
														</tbody>  
													</table> 
												</div>

												<!-- OCORRÊNCIAS DE CHEQUE (CCF) -->
												<div style="margin-top:2px; font-size:12px;" v-if="resultado.ccf.resumo['quantidade-total'] > 0">
													<h5>OCORRÊNCIAS DE CHEQUE (CCF)</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th>QTD. CHEQUES</th>
																<th>DT. ÚLTIMO</th>
																<th>AG</th>
																<th>BANCO</th>
																<th>MOTIVO</th>
																<th>ORIGEM</th>                            
															</tr>
														</thead>
														<tbody>
															<tr v-if="resultado.ccf['detalhe-ccf'].length == 1">
																<td>{{ resultado.ccf['detalhe-ccf'].quantidade }}</td>
																<td>{{ resultado.ccf['detalhe-ccf']['data-ultimo-cheque'] }}</td>
																<td>{{ resultado.ccf['detalhe-ccf']['ultimo-cheque']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ resultado.ccf['detalhe-ccf']['ultimo-cheque']['dados-bancarios'].banco.nome }}</td>
																<td>{{ resultado.ccf['detalhe-ccf'].motivo.descricao }}</td>
																<td>{{ resultado.ccf['detalhe-ccf'].origem }}</td>
															</tr>                                          

															<tr v-if="resultado.ccf['detalhe-ccf'].length > 1" v-for="item in resultado.ccf['detalhe-ccf']">
																<td>{{ item.quantidade }}</td>
																<td>{{ item['data-ultimo-cheque'] }}</td>
																<td>{{ item['ultimo-cheque']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ item['ultimo-cheque']['dados-bancarios'].banco.nome }}</td>
																<td>{{ item.motivo.descricao }}</td>
																<td>{{ item.origem }}</td>
															</tr>

														</tbody>  
													</table> 
												</div>

												<!-- RELAÇÃO DE CONTRA-ORDEM PARA OS CHEQUES CONSULTADOS -->
												<div style="margin-top:2px; font-size:12px;" v-if="resultado['contra-ordem'].resumo['quantidade-total'] > 0">
													<h5>RELAÇÃO DE CONTRA-ORDEM PARA OS CHEQUES CONSULTADOS</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th style="font-weight:bold; width:auto">DT. OCORRÊNCIA</th>
																<th style="font-weight:bold; width:auto">MOTIVO</th>
																<th style="font-weight:bold; width:auto">AG</th>
																<th style="font-weight:bold; width:auto">BANCO</th>
																<th style="font-weight:bold; width:auto">INFORMANTE</th>
																<th style="font-weight:bold; width:auto">ORIGEM</th>                            
															</tr>
														</thead>
														<tbody>
															<tr v-if="resultado['contra-ordem']['detalhe-contra-ordem'].length == 1">    
																<td>{{ resultado['contra-ordem']['detalhe-contra-ordem']['data-inclusao'] }}</td>
																<td>{{ resultado['contra-ordem']['detalhe-contra-ordem'].motivo.descricao }}</td>
																<td>{{ resultado['contra-ordem']['detalhe-contra-ordem']['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ resultado['contra-ordem']['detalhe-contra-ordem']['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ resultado['contra-ordem']['detalhe-contra-ordem'].informante }}</td>
																<td>{{ resultado['contra-ordem']['detalhe-contra-ordem'].origem }}</td>
															</tr>                                              

															<tr v-if="resultado['contra-ordem']['detalhe-contra-ordem'].length > 1" v-for="item in resultado['contra-ordem']['detalhe-contra-ordem']">    
																<td>{{ item['data-inclusao'] }}</td>
																<td>{{ item.motivo.descricao }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ item.informante }}</td>
																<td>{{ item.origem }}</td>
															</tr>     

														</tbody>  
													</table> 
												</div>

												<!-- RELAÇÃO DE CHEQUE/TALÃO SUSTADO COM DOCUMENTO DIFERENTE DO CONSULTADO -->
												<div style="margin-top:2px; font-size:12px;" v-if="resultado['contra-ordem-documento-diferente'].resumo['quantidade-total'] > 0">
													<h5>RELAÇÃO DE CHEQUE/TALÃO SUSTADO COM DOCUMENTO DIFERENTE DO CONSULTADO</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th style="font-weight:bold; width:auto">DOCUMENTO</th>
																<th style="font-weight:bold; width:auto">NÚMERO</th>
																<th style="font-weight:bold; width:auto">DT. OCORRÊNCIA</th>
																<th style="font-weight:bold; width:auto">MOTIVO</th>
																<th style="font-weight:bold; width:auto">AG</th>
																<th style="font-weight:bold; width:auto">BANCO</th>           
																<th style="font-weight:bold; width:auto">ORIGEM</th>                            
															</tr>
														</thead>
														<tbody>
															<tr v-if="resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente'].length == 1">    
																<td>{{ resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente'].documento }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente']['cheque-inicial'].numero }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente']['data-inclusao'] }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente'].motivo.descricao }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente']['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente']['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente'].origem }}</td>
															</tr>                                             

															<tr v-if="resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente'].length > 1" v-for="item in resultado['contra-ordem-documento-diferente']['detalhe-contra-ordem-documento-diferente']">    
																<td>{{ item.documento }}</td>
																<td>{{ item['cheque-inicial'].numero }}</td>
																<td>{{ item['data-inclusao'] }}</td>
																<td>{{ item.motivo.descricao }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ item.origem }}</td>
															</tr>       
														</tbody>  
													</table> 
												</div>

												<!-- CONTUMACIA -->

												<div style="margin-top:2px; font-size:12px;" v-if="resultado.contumacia.resumo['quantidade-total'] > 0">
													<h5>CONTUMACIA</h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th>NÚMERO</th>
																<th>DT. OCORRÊNCIA</th>
																<th>MOTIVO</th>
																<th>AG</th>
																<th>BANCO</th>
																<th>ORIGEM</th>                            
															</tr>
														</thead>
														<tbody>
															<tr v-if="resultado.contumacia.resumo['quantidade-total'] == 1">    
																<td>{{ resultado.contumacia['detalhe-contumacia']['cheque-inicial'].numero }}</td> 
																<td>{{ resultado.contumacia['detalhe-contumacia']['data-inclusao'] }}</td>
																<td>{{ resultado.contumacia['detalhe-contumacia'].motivo.descricao }}</td>
																<td>{{ resultado.contumacia['detalhe-contumacia']['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ resultado.contumacia['detalhe-contumacia']['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ resultado.contumacia['detalhe-contumacia'].origem }}</td>
															</tr>                                           

															<tr v-if="resultado.contumacia.resumo['quantidade-total'] > 1" v-for="item in resultado.contumacia['detalhe-contumacia']">    
																<td>{{ item['cheque-inicial'].numero }}</td> 
																<td>{{ item['data-inclusao'] }}</td>
																<td>{{ item.motivo.descricao }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios']['numero-agencia'] }}</td>
																<td>{{ item['cheque-inicial']['dados-bancarios'].banco.nome }}</td>
																<td>{{ item.origem }}</td>
															</tr>     
														</tbody>  
													</table> 
												</div>									
											</div>
										</div>
									</div>
									<div class="tab-pane" id="tab_outras">
										<div class="row">
											<div class="col-md-12 form-group">

												<!-- ENDEREÇOS -->
												<div style="margin-top:2px; font-size:12px;" v-if="resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado']">
													<h5>  ENDEREÇOS </h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th>LOGRADOURO</th>
																<th>NUMERO</th>
																<th>BAIRRO</th>
																<th>CEP</th>
																<th>CIDADE</th>
																<th>UF</th>
															</tr>
														</thead>
														<tbody>             
															<tr v-if="resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].length == 1" class= ''>
																<td>{{ resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].endereco.logradouro }}</td>
																<td>{{ resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].endereco.numero }}</td>
																<td>{{ resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].endereco.bairro }}</td>  
																<td>{{ resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].endereco.cep }}</td>
																<td>{{ resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].endereco.cidade.nome }}</td>
																<td>{{ resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].endereco.cidade.estado['sigla-uf'] }}</td>
															</tr>     

															<tr  v-if="resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado'].length > 1" v-for="item in resultado['ultimo-endereco-informado']['detalhe-ultimo-endereco-informado']">
																<td>{{ item.endereco.logradouro }}</td>
																<td>{{ item.endereco.numero }}</td>
																<td>{{ item.endereco.bairro }}</td>  
																<td>{{ item.endereco.cep }}</td>
																<td>{{ item.endereco.cidade.nome }}</td>
																<td>{{ item.endereco.cidade.estado['sigla-uf'] }}</td>
															</tr>                                               
														</tbody>  
													</table>
												</div> 

												<!-- DADOS DE TELEFONIA -->									 
												<div style="margin-top:2px; font-size:12px;" v-if="resultado['ultimo-telefone-informado']['detalhe-ultimo-endereco-informado']">
													<h5>  DADOS DE TELEFONIA </h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th style="font-weight:bold; width:auto">TELEFONE</th>
																<th style="font-weight:bold; width:auto">UF</th>
																<th style="font-weight:bold; width:auto">ASSINANTE</th>
															</tr>
														</thead>
														<tbody>   
															<tr v-if="resultado['ultimo-telefone-informado']['detalhe-ultimo-endereco-informado'].length == 1">
																<td>{{ resultado['ultimo-telefone-informado']['detalhe-ultimo-telefone-informado'].assinante.telefone['numero-ddd'] }}</td>
																<td>{{ resultado['ultimo-telefone-informado']['detalhe-ultimo-telefone-informado'].assinante.endereco.cidade.nome }} - {{resultado['ultimo-telefone-informado']['detalhe-ultimo-telefone-informado'].assinante.endereco.cidade.estado['sigla-uf'] }}</td>
																<td>{{ resultado['ultimo-telefone-informado']['detalhe-ultimo-telefone-informado'].assinante.nome }}</td>
															</tr> 

															<tr v-if="resultado['ultimo-telefone-informado']['detalhe-ultimo-endereco-informado'].length > 1" v-for="item in resultado['ultimo-telefone-informado']['detalhe-ultimo-endereco-informado']">
																<td>{{ item.assinante.telefone['numero-ddd'] }}</td>
																<td>{{ item.assinante.endereco.cidade.nome }} - {{item.assinante.endereco.cidade.estado['sigla-uf'] }}</td>
																<td>{{ item.assinante.nome }}</td>
															</tr>                
														</tbody>  
													</table>
												</div>									
											</div>
										</div>
									</div>
									<div class="tab-pane" id="tab_alertas">
										<div class="row">
											<div class="col-md-12 form-group">
												<!-- HISTÓRICOS DE CONSULTAS -->
												<div style="margin-top:2px; font-size:12px;" v-if="resultado['consulta-realizada'].resumo['quantidade-total'] > 0">
													<h5>  HISTÓRICOS DE CONSULTAS </h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th style="font-weight:bold; width:auto">DT.CONSULTA</th>
																<th style="font-weight:bold; width:auto">CONSULTANTE</th>
																<th style="font-weight:bold; width:auto">ORIGEM</th>
															</tr>
														</thead>

														<tbody>
															<tr v-if="resultado['consulta-realizada'].resumo['quantidade-total'] == 1">
																<td>{{ resultado['consulta-realizada']['detalhe-consulta-realizada']['data-consulta'] }}</td>
																<td>{{ resultado['consulta-realizada']['detalhe-consulta-realizada']['nome-associado'] }}</td>
																<td>{{ resultado['consulta-realizada']['detalhe-consulta-realizada']['nome-entidade-origem'] }}</td>                
															</tr>

															<tr v-if="resultado['consulta-realizada'].resumo['quantidade-total'] > 1" v-for="item in resultado['consulta-realizada']['detalhe-consulta-realizada']">
																<td>{{ item['data-consulta'] }}</td>
																<td>{{ item['nome-associado'] }}</td>
																<td>{{ item['nome-entidade-origem'] }}</td>            
															</tr>

														</tbody>  
													</table>
												</div>

												<!-- ALERTAS -->

												<div style="margin-top:2px; font-size:12px;" v-if="resultado['alerta-documento'].resumo['quantidade-total'] > 0">
													<h5>  ALERTAS </h5>
													<table class="table table-bordered table-striped table-hover">
														<thead>
															<tr class= ''>
																<th>TIPO</th>
																<th>DT.OCORRÊNCIA</th>
																<th>CONSULTANTE</th>
																<th>MOTIVO</th>
															</tr>
														</thead>

														<tbody>        

															<tr v-if="resultado['alerta-documento'].resumo['quantidade-total'] == 1">
																<td>{{ resultado['alerta-documento']['detalhe-alerta-documento']['tipo-documento-alerta'].nome }}</td>
																<td>{{ resultado['alerta-documento']['detalhe-alerta-documento']['data-inclusao'] }}</td>
																<td>{{ resultado['alerta-documento']['detalhe-alerta-documento']['entidade-origem'] }}</td>   
																<td>{{ resultado['alerta-documento']['detalhe-alerta-documento'].motivo }}</td>              
															</tr>

															<tr v-if="resultado['alerta-documento'].resumo['quantidade-total'] > 1">
																<td>{{ item['tipo-documento-alerta'].nome }}</td>
																<td>{{ item['data-inclusao'] }}</td>
																<td>{{ item['entidade-origem'] }}</td>   
																<td>{{ item.motivo }}</td>              
															</tr>

														</tbody>  
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- /.content -->
		</template>



		<script>

			export default {
				props: ['resultado'],
				components: {

				},
				data: () => ({

				}),
				mounted() {

				},
				methods: {

				},
				watch: {

				}
			}
		</script>

		<style scoped>

		</style>



// WEBPACK FOOTER //
// ResultadoRestritiva.vue?167770dc